/**
 * Replace hyphens with underscores, split into array of characters, uppercase character that is not first and not a . or _ is prepended an underscore, join into one string, transform to uppercase. If the input string you want to turn into snake case is already in uppercase, you're SOL.
 * @param input string you wish to convert (MUST BE lowercase)
 * @returns string in uppercase snake case
 * @example converToSnakeCase("camelCase") => "CAMEL_CASE"
 * @example converToSnakeCase("kebab-case") => "KEBAB_CASE"
 * @example converToSnakeCase("snake_case") => "SNAKE_CASE"
 * @example converToSnakeCase("PascalCase") => "PASCAL_CASE"
 */
export const convertToSnakeCase: (input: string) => string = (input: string): string => {
    let output = input;

    if (input !== input.toUpperCase()) {
        output = input
            .replace('-', '_')
            .split('')
            .map((character, index) => {
                if (character === character.toUpperCase() && index > 0 && character !== '.' && character !== '_') {
                    return '_' + character;
                } else {
                    return character;
                }
            })
            .join('')
            .toUpperCase();
    }

    return output;
};
